const SET_TITLE = 'SET_TITLE';
const PUSH_TITLE = 'PUSH_TITLE';
export default {
	state: {
		titleList: [],
		isCollapse: false,      // 菜单是否折叠
	},
	getters: {
		getTitleList: state => state.titleList,
		isCollapse: state => state.isCollapse
	},
	mutations: {
		SET_TITLE(state, list) {
			state.titleList = list;
		},
		PUSH_TITLE(state, list) {
			state.titleList.push(list);
		},
		setIsCollapse(state, isCollapse) {
			state.isCollapse = isCollapse;
		}
	},
	actions: {
		setTitle({commit}, list) {
			commit(SET_TITLE, list);
			window.window.sessionStorage.titleList = JSON.stringify(list);
		},
		pushTitle({commit}, list) {
			commit(PUSH_TITLE, list);
		},
		// 赋值
		setIsCollapse({commit}, isCollapse) {
			commit('setIsCollapse', isCollapse);
		}
	}
};



// WEBPACK FOOTER //
// ./main/store/head-title.js